import React , {Component} from "react";
import MyContext from '../MyContext.jsx';
import {Link} from "react-router-dom";
import { CgSearch } from 'react-icons/cg';
import Select from "react-select";
import DatePicker from 'react-date-picker';


import './VisitFrequencyReport.scss';

class VisitFrequencyReport extends Component{
  constructor(props){
    super(props);
    this.executiveSelect = React.createRef();

    this.state = {
      executives    :   [],
      executive :   {},
      doctors : [],
      showing_doctors:[],
      search:'',
      from_date : new Date(),
      to_date : new Date(),
    }
    this.executiveChange = this.executiveChange.bind(this);
    this.formChange = this.formChange.bind(this);
    this.formSubmit = this.formSubmit.bind(this);


  }
  componentDidMount(){
    var obj_this = this;
    const url = `${process.env.REACT_APP_SSS}/api/Reports/getExecutives`;
    this.context.loading(1);
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
         executives : return_data.executives,
        });
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
        obj_this.context.loading(0);
        alert("Network error");
    });

    
  }

  formChange(e){
    // console.log(e.target.value);
    var showing_doctor =[];
    if(e.target.value){
      showing_doctor = this.state.showing_doctors.filter((item) => {return item.influencer_name.toLowerCase().includes(e.target.value.toLowerCase())});
    }
    else{
      showing_doctor = this.state.doctors;
    }
    // showing_doctors = showing_doctors.length?showing_doctors:this.state.doc_name;
    this.setState({
      showing_doctors : showing_doctor
    });
  }

  executiveChange(option){
    this.setState({
      executive : option
    });
  } 

  formSubmit(e){
    e.preventDefault();
    $(".customer_outstandings_table tr").css("backgroud-color","");
    if(!this.state.executive.value){
      this.executiveSelect.current.focus();
      return;
    }
    
    var obj_this = this;
    const url2 = `${process.env.REACT_APP_SSS}/api/Reports/getVisitFrequency`;
    this.context.loading(1);
    $.ajax({
      url : url2,
      data : {
        sid : this.context.user_details.sid,
        executive_id : this.state.executive.value,
        from_date : this.state.from_date.toLocaleDateString('en-CA'),
        to_date : this.state.to_date.toLocaleDateString('en-CA')
        // due_period_id : this.state.due_period.value
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      // doctors = doctors.sort(function(a,b){
      //   return a.no_due - b.no_due
      // });
      // return;
      
      if(return_data.status == "success"){
        obj_this.setState({
         doctors : return_data.doctors,
         showing_doctors:return_data.doctors
        });
        // debugger;
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
   
    
  }
  fromDateChange(value){
    // console.log(value);
    this.setState({from_date : value});
  }
  toDateChange(value){
    // console.log(value);
    this.setState({to_date : value});
  }




  
    

  render(){
    return(
      <MyContext.Consumer>
        {context => (
        <div className="executive_visit_frequency_page_container">
          <div className="page_header">
            <Link className="back_button" to="/reports"><i className="fas fa-arrow-left"></i></Link>
            <div className="page_title">Visit Frequency Report</div>
          </div> 
          <form className="executive_due_period_form" onSubmit={this.formSubmit}>
            <div className="blocks">
              <div className="form_input">
                  <div className="from_to_label">
                      <div className="input_label">From Date</div>
                      <DatePicker
                        className="input custom_input"
                        onChange={(value) => this.fromDateChange(value)}
                        value={this.state.from_date}
                        // minDate = {new Date()}
                        clearIcon={null}
                        required
                        format="dd-MM-y"
                      />
                      <div className="input_label">To Date</div>
                      <DatePicker
                        className="input custom_input"
                        onChange={(value) => this.toDateChange(value)}
                        value={this.state.to_date}
                        minDate = {new Date(this.state.from_date)}
                        clearIcon={null}
                        required
                        format="dd-MM-y"
                      />
                  </div>
                  <div className="input_label">Executive</div>
                  <Select 
                    options={this.state.executives}  
                    value ={this.state.executive}
                    className="executive" 
                    ref={this.executiveSelect}
                    onChange={e => this.executiveChange(e)}
                    required
                  />
                  <div className="submit_button_container">
                    <button className="submit_button">Submit</button>
                  </div>
                </div>
                
            </div>
          </form>
          <div className="search_container">
            <CgSearch/>
            <input className="customer_search_input" 
              placeholder="Search doctor.."
              onChange={this.formChange}
              value={this.search}
            />
          </div>
          <div className="table_container">
            <table className="customer_outstandings_table">
              <thead>
                <tr>
                  <th style={{maxWidth:"40px"}} align="center">#</th>
                  <th>Doctor</th>
                </tr>
              </thead>
              <tbody>
              <tr style={{display:this.state.showing_doctors.length?"none":"table-row"}}>
                <td colSpan="2" align="center">No result!</td>
              </tr>
              {this.state.showing_doctors && this.state.showing_doctors.map((cust,index) => (
                <tr key={index}  style={{backgroundColor:cust.checkin.length<4 ?"#ffa8b3":""}}>
                  <td valign="top" align="center">{index+1}</td>
                  <td valign="top" style={{padding:"5px 0px"}}>
                    <div style={{fontWeight:"500",paddingLeft:"5px"}}>{cust.influencer_name}</div>
                    <div className="bills_table_container" style={{display:cust.checkin.length>0?"block":"none"}}>
                      {/* <span style={{display:cust.checkin.length==0?"block":"none"}}>
                        <span style={{align:"center"}}>No Check in !!!</span>
                      </span> */}
                      <table className="bills_table input-grid" >
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody >
                          {cust.checkin.map((custs,idx) => (
                          <tr key={idx}>
                            <td>{custs.check_in}</td>
                            <td>{custs.remarks}</td>
                          </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              ))}
              </tbody>
            </table>
          </div>
        </div>

      )}
    </MyContext.Consumer>
  )}
}

export default VisitFrequencyReport;
VisitFrequencyReport.contextType = MyContext;
